import { render, staticRenderFns } from "./designs_dashboard.vue?vue&type=template&id=30814df8"
import script from "./designs_dashboard.vue?vue&type=script&lang=js"
export * from "./designs_dashboard.vue?vue&type=script&lang=js"
import style0 from "./designs_dashboard.vue?vue&type=style&index=0&id=30814df8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports